export const SPORTS = [
  "Aikido",
  "Athlétisme",
  "Badminton",
  "Basketball",
  "Biathlon",
  "Boxe",
  "Boxe anglaise",
  "Boxe thaïlandaise (Muay Thai)",
  "Canoë-kayak",
  "Cyclisme",
  "CrossFit",
  "Course à pied",
  "Danse sportive",
  "Escalade",
  "Escrime",
  "Football",
  "Football américain",
  "Golf",
  "Gymnastique",
  "Haltérophilie",
  "Handball",
  "Hockey sur glace",
  "Judo",
  "Karaté",
  "Kitesurf",
  "Lutte",
  "Musculation",
  "Natation",
  "Padel",
  "Parachutisme",
  "Patinage artistique",
  "Patinage de vitesse",
  "Pilates",
  "Plongée",
  "Randonnée / Trail",
  "Roller / Skateboard",
  "Rugby",
  "Ski alpin",
  "Ski de fond",
  "Snowboard",
  "Sports équestres",
  "Squash",
  "Surf",
  "Taekwondo",
  "Tennis",
  "Tennis de table",
  "Tir à l'arc",
  "Triathlon",
  "Voile",
  "Volley-ball",
  "Yoga",
  "Autre"
];
